import { Alert } from '@folio/components';
import { AlertOctagonIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Group } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';

export function ZeroPremiumErrorBanner() {
  const { t } = useTranslation();

  return (
    <Alert variant="destructive" className="bg-card">
      <Group>
        <AlertOctagonIcon className="shrink-0" />
        <Text size="sm">{t('quoteFunnel.zeroPremiumError')}</Text>
      </Group>
    </Alert>
  );
}
